import { makeStyles } from "tss-react/mui";
import { MiButton } from "@miplatform/components";
import { BUTTON_VARIANTS } from "@miplatform/constants";
import { ICalendarWorkTemplateBase, IDetailField } from "@miplatform/types";
import { mdiPlus } from "@mdi/js";
import { Box, Typography } from "@mui/material";
import { WorkTemplateBaseAutoAssignTimeWindows } from "./WorkTemplateBaseAutoAssignTimeWindows";
import { DraftWindow } from "./useEditTimeWindowsModalViewModel";

export const WorkTemplateBaseList = ({
  workTemplateBases,
  draftWindowsByTemplateId,
  overlappingByTemplateId,
  isSaving,
  onAddWindow,
  onRemoveWindow,
  getWindowFields,
}: WorkTemplateBaseListProps) => {
  const { classes } = useStyles();

  return (
    <>
      {workTemplateBases.map((template) => {
        const windows = draftWindowsByTemplateId[template.id] ?? [];
        const overlappingIndices =
          overlappingByTemplateId[template.id] ?? new Set<number>();

        return (
          <Box key={template.id} className={classes.templateSection}>
            <Box className={classes.templateHeader}>
              <Typography variant="subtitle2" fontWeight={600}>
                {template.name}
              </Typography>
              <MiButton
                title="Time Window"
                variant={BUTTON_VARIANTS.OUTLINED}
                startIcon={{ path: mdiPlus }}
                onClick={() => onAddWindow(template.id)}
                disabled={isSaving}
                className={classes.addButton}
              />
            </Box>
            <WorkTemplateBaseAutoAssignTimeWindows
              templateId={template.id}
              templateName={template.name}
              windows={windows}
              overlappingIndices={overlappingIndices}
              isSaving={isSaving}
              getWindowFields={(index) => getWindowFields(template.id, index)}
              onRemoveWindow={(index) => onRemoveWindow(template.id, index)}
            />
          </Box>
        );
      })}
    </>
  );
};

interface WorkTemplateBaseListProps {
  workTemplateBases: ICalendarWorkTemplateBase[];
  draftWindowsByTemplateId: Record<string, DraftWindow[]>;
  overlappingByTemplateId: Record<string, Set<number>>;
  isSaving: boolean;
  onAddWindow: (templateId: string) => void;
  onRemoveWindow: (templateId: string, index: number) => void;
  getWindowFields: (templateId: string, index: number) => IDetailField[];
}

const useStyles = makeStyles()((theme) => ({
  templateSection: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
  templateHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
  },
  addButton: {
    height: 28,
    fontSize: 12,
    flexShrink: 0,
  },
}));
